export const NAV_ITEMS = [
  {
    label: "Home",
    path: "/",
  },
  {
    label: "Academics",
    path: "/academics",
    children: [
      { label: "S-Tee Culture", path: "/academics/culture" },
      { label: "School Anthem", path: "/academics/anthem" },
      { label: "School Creed", path: "/academics/creed" },
    ],
  },
  {
    label: "Founder & Director",
    path: "/founder-director",
  },
  {
    label: "Admissions",
    path: "/admissions",
    children: [
      { label: "Apply to S-Tee", path: "/admissions/apply" },
      { label: "Apply for Online School", path: "/admissions/online-school" },
      { label: "Download Prospectus", path: "/admissions/prospectus" },
      { label: "Latest News", path: "/admissions/latest-news" },
    ],
  },
  {
    label: "Portal",
    children: [
      { label: "Educator", kind: "portal", role: "educator" },
      { label: "Student", kind: "portal", role: "student" },
      { label: "Parent", kind: "portal", role: "parent" },
      { label: "CBT", kind: "cbt" },
    ],
  },
  {
    label: "Gallery",
    path: "/gallery",
  },
  {
    label: "Career",
    path: "/career",
  },
  {
    label: "About",
    path: "/about",
  },
  {
    label: "Contact",
    path: "/contact",
  },
];
